import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_green.css';

import { InputBackOffice } from '../../components/common/InputBackoffice';
import { Label } from '../../styles/stylesStyled';
import { useState } from 'react';
import { Button, ErrorToast } from '../../components';
import { useDispatch } from 'react-redux';
import { createWebinarMenagement } from '../../slices/webinars-slice';
import moment from 'moment';
import { InvoiceHeader, Invoices } from '../Accounting/AccountingStyled';
import { Flexed } from '../../styles/GlobalComponents';

const SoldTickets = ({
  setIsTicketModalOpen,
  tickets
}: {
  tickets: any;
  setIsTicketModalOpen: any;
}) => {
  return (
    <div>
      <InvoiceHeader>
        <div style={{ width: '25%' }}>User ID</div>
        <div style={{ width: '25%' }}>Date Created</div>
        <div style={{ width: '25%' }}>Date Paid</div>
        <div style={{ width: '25%' }}>Status</div>
      </InvoiceHeader>
      {tickets?.map((ticket: any, index: number) => {
        return (
          <Invoices key={index}>
            <div style={{ width: '25%' }}>{ticket?.userId}</div>
            <div style={{ width: '25%' }}>
              {moment.utc(ticket?.dateCreated).format('DD/MM/YY')}
            </div>
            <div style={{ width: '25%' }}>
              {ticket?.datePaid &&
                moment.utc(ticket?.datePaid).format('DD/MM/YY')}
            </div>

            <div style={{ width: '25%' }}>{ticket?.status}</div>
          </Invoices>
        );
      })}
    </div>
  );
};

export default SoldTickets;
